import React from "react";
import Spinner from 'react-bootstrap/Spinner';

function Load() {
  return (<>
      <Spinner animation="border" variant="light"  />
    </> )
}

export default Load;